// extracted by mini-css-extract-plugin
export default {"no-scrollbar":"CanScrollMask_no-scrollbar__1UXCA"};